Ext.define('SA.HistogramLegendSummary', {
    alias: 'widget.histogram-legend-summary',
    extend: 'SA.ChartLegendContent',

    items: [
        {
            xtype: 'chart-legend-summary-property',
            itemId: 'chartTitle',
            name: 'Chart Title'
        }, {
            xtype: 'chart-legend-summary-property',
            itemId: 'yAxisTitle',
            name: 'Y-Axis'
        }, {
            xtype: 'chart-legend-summary-property',
            itemId: 'attribute',
            name: 'X-Axis'
        }, {
            xtype: 'chart-legend-summary-property',
            itemId: 'binSize',
            name: 'Bin Size (Bar Width)'
        }
    ],

    initComponent() {
        this.callParent();

        this.chartTitle = this.down('#chartTitle');
        this.yAxisTitle = this.down('#yAxisTitle');
        this.attribute = this.down('#attribute');
        this.binSize = this.down('#binSize');
    },

    setState(state) {
        this.chartTitle.setVisible(!!state.model.chartTitle);
        this.chartTitle.setValue(state.model.chartTitle);
        this.yAxisTitle.setValue(state.model.yAxisTitle);
        this.attribute.setValue(state.model.attributes.selected.label);
        this.binSize.setValue(state.binSize.formattedSize);
    }
});
